module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/AJAasQ/tc-custom/9781473880924.jpg?1707880585498",
      "alt": "This image is the cover for the book Tank Warfare on the Eastern Front, 1943–1945"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Tank Warfare on the Eastern Front, 1943–1945\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The author of "), _c('i', [_vm._v("Case White")]), _vm._v(" offers an extensive history of German and Soviet armored warfare toward the end of World War II.")]), _c('br'), _c('br'), _vm._v(" By 1943, after the catastrophic German defeat at Stalingrad, the Wehrmacht’s panzer armies gradually lost the initiative on the Eastern Front. The tide of the war had turned. Their combined arms technique, which had swept Soviet forces before it during 1941 and 1942, had lost its edge. Thereafter the war on the Eastern Front was dominated by tank-led offensives and, as Robert Forczyk shows, the Red Army’s mechanized forces gained the upper hand, delivering a sequence of powerful blows that shattered one German defensive line after another. His incisive study offers fresh insight into how the two most powerful mechanized armies of the Second World War developed their tank tactics and weaponry during this period of growing Soviet dominance. He uses German, Russian, and English sources to provide the first comprehensive overview and analysis of armored warfare from the German and Soviet perspectives. This major study of the greatest tank war in history is compelling reading.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Robert Forczyk\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Pen and Sword\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0